module.exports = __webpack_public_path__ + "img/796F52_36413A_C9B48C_B6A77F-256px.c949da55.png";